import { Component, Input } from '@angular/core';

@Component({
    selector: 'progress-spinner',
    templateUrl: './progress-spinner.component.html',
    styleUrl: './progress-spinner.component.scss',
    standalone: false
})
export class ProgressSpinnerComponent {

  @Input() isLLMTrainig: boolean = false;

}
